import React from "react";
import loadable from "@loadable/component";
const Loader = () => {
    return <div />;
};

export default loadable(() => import(/* webpackChunkName: 'request_popup' */ "./index"), {
    fallback: <Loader />,
});
